import { Component } from '@angular/core';
import { AbstractItemRow } from '../../../shared/components/abstract-item-row/abstract-item-row';
import { ThumbSourceFactoryService } from '../../../shared/services/thumb-source-factory.service';

@Component({
    selector: 'payment-resume-row',
    templateUrl: './payment.resume.row.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentResumeRowComponent extends AbstractItemRow {

    hideToggledExtraFields = false;
    hideToggledAttributesExtraFields = false;

    constructor(
        protected thumbFactory: ThumbSourceFactoryService
    ) {
        super();
        this.thumbFactory = thumbFactory;
    }

    toggleFieldsSpecificCSSClasses() {
        this.hideToggledExtraFields = !this.hideToggledExtraFields;
    }
    toggleAttributesExtraFieldsSpecificCSSClasses() {
        this.hideToggledAttributesExtraFields = !this.hideToggledAttributesExtraFields;
    }

    /** Create an object with dynamic CSS classes for the extra fields' <div>.
     * The object has this structure:
     * "slug": CSS class with the same name as the extra field slug. Agencies should use to stylize labels and values
     * "toggleSlug": CSS class that concatenates 'toggle-' with slug. Agency should use to define which fields should be toggled by button
     * @param slug extra field's slug. This identifies each CSS class, letting agencies specify CSS rules to each extra field individually
     */
    getExtraFieldStyle(slug) {
        const hideSlug = 'hide-' + slug;
        return {
            [slug]: true,
            [hideSlug]: this.hideToggledExtraFields
        };
    }

    /** Create an object with dynamic CSS classes for the attributes extra
     *  fields' <div>.
     * The object has this structure:
     * "slug": CSS class with the same name as the extra field slug. Agencies should use to stylize labels and values
     * "toggleSlug": CSS class that concatenates 'toggle-' with slug. Agency should use to define which fields should be toggled by button
     * @param slug extra field's slug. This identifies each CSS class, letting agencies specify CSS rules to each extra field individually
     */
    getAttributesExtraFieldStyle(slug) {
        const hideSlug = 'hide-' + slug;
        return {
            [slug]: true,
            [hideSlug]: this.hideToggledAttributesExtraFields
        };
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/resume/row/payment.resume.row.component.ts